import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import SetupAgreeRepository from '@/repositories/setupAgreeRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSetupAgreeStore = defineStore({
    id: 'setupAgreee',
    state: () => ({
        regulationPk: null,
    }),
    getters: {
        getRegulationPk() {
            return this.RegulationPk;
        },
    },
    actions: {
        reset() {
            this.regulationPk = null;
        },

        /**
         * 利用規定同意画面の同意の登録処理。
         */
        async setupUserAgreementUpdateAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const setupAgreeRepository = new SetupAgreeRepository();
            try {
                // ユーザー利用規定同意登録APIをコールする。
                const response = await setupAgreeRepository.postUserAgreementUpdateActionApi(API_URL, requestBody, idToken);

                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        // セッションストレージに保存する。
        storage: sessionStorage,
    },
});
